// language=GraphQL
export const ALL_EMPLOYEES_QUERY = `query Query($withImage: Boolean = false) {
  employees: employees {
    id
    firstName
    lastName
    jobTitle
    description
    email
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    phone
  }
}`

// language=GraphQL
export const SINGLE_EMPLOYEE_QUERY = `query Query($id: ID!, $withImage: Boolean = false) {
  employee: employee(id: $id) {
    id
    firstName
    lastName
    jobTitle
    description
    email
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    phone
  }
}`

// language=GraphQL
export const CREATE_EMPLOYEE_MUTATION = `
  mutation Mutation($input: CreateEmployeeInput, $withImage: Boolean = false) {
    employee: createEmployee(input: $input) {
      id
      firstName
      lastName
      jobTitle
      description
      email
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      phone
    }
  }`

// language=GraphQL
export const UPDATE_EMPLOYEE_MUTATION = `
  mutation Mutation($input: UpdateEmployeeInput, $withImage: Boolean = false) {
    employee: updateEmployee(input: $input) {
      id
      firstName
      lastName
      jobTitle
      description
      email
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      phone
    }
  }`

// language=GraphQL
export const DELETE_EMPLOYEE_MUTATION = `
  mutation Mutation($input: DeleteEmployeeInput) {
    deleteEmployee(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_EMPLOYEE_MUTATION = `
  mutation Mutation($input: DeleteEmployeeInput) {
    forceDeleteEmployee(input: $input) {
      success
    }
  }`
// language=GraphQL
export const EMPLOYEES_DEPENDENTS_QUERY = `query Query($id: ID!, $withCmsContactBannerBlocks: Boolean = false, $withTravels: Boolean = false, $withTenants: Boolean = false, $withCmsEmployeesBlocks: Boolean = false) {
  groupedDependents: employeeDependents(id: $id) {
    cmsContactBannerBlocks @include(if: $withCmsContactBannerBlocks) {
      id
      phone
      email    }
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency    }
    tenants @include(if: $withTenants) {
      id
      name
      slug
      domain
      externalReference
    }
    cmsEmployeesBlocks @include(if: $withCmsEmployeesBlocks) {
      id
    }
  }
}`
